var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('g-master',{ref:"master",attrs:{"name":_vm.master.endpoint,"endpoint":_vm.master.endpoint,"tableSetup":_vm.master.tableSetup,"modalWidth":"80%","parentData":_vm.parentData,"actions":false},scopedSlots:_vm._u([{key:"estadoRenderer",fn:function(ref){
var text = ref.text;
return _c('span',{},[_c('a-icon',_vm._b({},'a-icon',_vm.fillIcon(text),false))],1)}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0444128","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customization/GlobalBPOCore/pages/Capacitaciones/AsistenciaYEvaluacion.vue
// module id = null
// module chunks = 